<script lang="tsx">
  import { computed, type PropType } from "vue";

  import { useQuery } from "@urql/vue";
  import { graphql as gql } from "@/gql";
  import type { image_Entry, Scalars } from "@/gql/graphql";

  export default {
    props: {
      entry: {
        type: [Number, String, Boolean, Object] as PropType<Scalars["QueryArgument"]["input"] | image_Entry>,
        required: true,
      },
      transform: String,
    },
    async setup(props) {
      const { data } = await useQuery({
        query: gql(`
          query FetchImageEntry($id: QueryArgument, $transform: String, $doTransform: Boolean!) {
            entry(id: [$id]) {
              id,
              ... on image_Entry {
                image @skip(if: $doTransform) {
                  title, alt, url, width, height
                }
                image @include(if: $doTransform) @transform(transform: $transform) {
                  title, alt, url, width, height
                }
              }
            }
          }
        `),
        variables: {
          id: props.entry as Scalars["QueryArgument"]["input"],
          transform: props.transform,
          doTransform: props.transform !== undefined,
        },
        pause: () => typeof(props.entry) === "object",
      });
      return {
        image: computed(() => {
          return typeof(props.entry) === "object"
            ? props.entry : data.value!.entry! as image_Entry;
        }),
      };
    },
    computed: {
      asset() { return this.image.image[0]!; },
    },
  };
</script>

<template>
  <img :src="asset.url ?? undefined"
    :title="asset.title ?? undefined" :alt="asset.alt ?? undefined"
    :width="asset.width ?? undefined" :height="asset.height ?? undefined" />
</template>

<style lang="less" scoped>
img {
  display: block;
  width: auto;
  height: auto;
}
</style>
